<template>
  <div class="fileInput">
    <div v-if="defaultValue||value" :style="{backgroundImage: `url(.${defaultValue})`}" @click="del"/>
    <label for="file" v-else>
      <div class="imgnote"  title="點擊上傳圖片"></div>
      <input type="file" id="file" name="file" @change="upload" :disabled="disabled">
      <div class="insertImage">匯入</div>
    </label>
  </div>

</template>

<script>
import { uploadimage } from '../../store/fetch'
export default {
  name: 'FileInput',
  props: ['defaultValue', 'folder', 'disabled'],
  data () {
    return {
      value: null
    }
  },
  methods: {
    del () {
      if (!this.disabled) {
        this.$emit('input', null)
      }
    },
    async upload (ev) {
      if (ev.target.files[0]) {
        const ret = await uploadimage(ev, this.folder)
        const image = ret
        image.filename = `/${this.folder}/${image.filename}`
        this.$emit('input', image.filename)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.fileInput {
  margin: auto;
  width: 120px;
  height: 120px;
  background-color: #D9D9D9;
  display: flex;
  align-items: center;
  justify-content: center;
  &>div:nth-child(1) {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.imgnote {
  width: 55px;
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &::before {
    content: '';
    display: inline-block;
    width: 55px;
    height: 30px;
    background-image: url(/svg/btn/camera.svg);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  &::after {
    display: inline-block;
    content: '請上傳圖片';
    white-space: nowrap;
    font-weight: 400;
    font-size: 11px;
    line-height: 180%;
    color: #FFFFFF;
  }
}
label {
  input[type=file] {
    display: none;
  }
}
label {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-top: 19px;
  .insertImage {
    background-color: var(--color-checked);
    width: 80px;
    height: 30px;
    border-radius: 20px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0;
    font-weight: 400;
    color: #FFFFFF;
    font-size: 14px;
  }
}
</style>
